export default "__VITE_ASSET__K18I_4W___"